/* Core & libraries */

/* Helpers, constants, custom methods, internal libraries */
import { CHOICE_DISMISS_TIER_BANNER_ENDPOINT } from "../endpoints/endpoints";
import { useGenericApiFetch } from 'endpoints/base';
import { useUserContext } from 'contexts/userContext';
/* Components */
/* Styles */

export const useBannerService = () => {
const userDetails = useUserContext();
const { genericApiFetch } = useGenericApiFetch();
const companyEntityId = userDetails?.userInfo?.companyInfo?.companyEntityId;

const dismissTierBanner = async (payload) => {
    const response = await genericApiFetch({
      url: CHOICE_DISMISS_TIER_BANNER_ENDPOINT.replace("{companyEntityId}", companyEntityId),
      method: "POST",
      data : payload,
    });
    if (response.success) {
      return true;
    }
    return false;
  };

   return {
    dismissTierBanner
  };
}